function Academic() {
    return (
        <div className="academic">


        </div>
    );
}

export default Academic;